import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CalculateIcon from '@mui/icons-material/Calculate';
import { CONTACT_EMAIL, FOOTER } from '../demoContent';

/** Slim demo footer: wordmark, a way to reach a human, and the legal pages. Nothing else. */
export default function DemoFooter() {
  return (
    <Box
      component="footer"
      sx={{ bgcolor: 'background.paper', borderTop: '1px solid', borderColor: 'divider', py: 4 }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CalculateIcon sx={{ color: 'primary.main', fontSize: 22 }} />
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: 16, color: 'primary.main', lineHeight: 1.2 }}>
                MathWiz{' '}
                <Box component="span" sx={{ fontWeight: 400, color: 'text.primary' }}>
                  League
                </Box>
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {FOOTER.tagline}
              </Typography>
            </Box>
          </Box>

          <Stack direction="row" spacing={3} alignItems="center">
            <Link
              href={`mailto:${CONTACT_EMAIL}`}
              underline="hover"
              sx={{ fontSize: 14, color: 'text.secondary' }}
            >
              Contact
            </Link>
            <Link
              component={RouterLink}
              to="/privacy"
              underline="hover"
              sx={{ fontSize: 14, color: 'text.secondary' }}
            >
              Privacy
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              underline="hover"
              sx={{ fontSize: 14, color: 'text.secondary' }}
            >
              Terms
            </Link>
          </Stack>
        </Stack>

        <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'text.disabled' }}>
          © {new Date().getFullYear()} MathWiz League
        </Typography>
      </Container>
    </Box>
  );
}
